import { LonLat } from './lon-lat.types';

/**
 * Type guard function to check if a value is a LonLat coordinate object.
 * Verifies that the object contains both 'lat' and 'lon' properties.
 *
 * @example
 * ```ts
 * if (isLonLatCoordinate(someValue)) {
 *   // TypeScript now knows someValue has lat and lon properties
 *   console.log(someValue.lat, someValue.lon);
 * }
 * ```
 *
 * @param value - The value to check
 * @returns True if the value is a LonLat coordinate with lat and lon properties
 */
export const isLonLatCoordinate = (value: unknown): value is LonLat => {
  return (
    typeof value === 'object' &&
    value !== null &&
    'lat' in value &&
    'lon' in value
  );
};
